/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-08-03 16:25:11
 **/

import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Column, Row } from "@/frameworks/designStuff/components";

export const EmptyUser = styled(Row)`
	width: 72px;
	height: 76px;
	background-color: ${({ theme }) => theme.colors.neutral_50_8};
	border-radius: 12px;
`;

export const AddUserWrapper = styled(Column)`
	background-color: ${({ theme }) => theme.colors.neutral_00_100};
	border-radius: 20px;
	height: 612px;
	width: 356px;
	gap: 12px;
	box-shadow: 4px 0 20px 0 rgba(0, 0, 0, 0.2);
	backdrop-filter: blur(14px);
`;

export const GridUserItemStyled = styled(Column.li)<{ backgroundColor?: string; selected?: boolean }>`
	background: ${({ backgroundColor }) => backgroundColor || "transparent"};
	width: 71px;
	height: 77px;
	padding: 6px;

	position: relative;
	border-radius: 12px;
	${({ selected, theme }) => {
		if (!selected)
			return css`
				cursor: pointer;
				&:hover {
					background-color: ${theme.colors.neutral_20_100};
				}
				&:active {
					background-color: ${theme.colors.accent_10_100};
				}
				-webkit-user-select: none;
				-moz-user-select: none;
				-ms-user-select: none;
				user-select: none;
			`;
	}};
`;

export const EmptySearch = styled(Column)`
	width: 100%;
	height: 100%;
	align-items: center;
	justify-content: center;
`;

export const UserStatusIconWrapper = styled(Row)<{ status: boolean }>`
	position: absolute;
	top: 0;
	right: 0;
	width: 20px;
	height: 20px;
	border-radius: 16px;
	background: ${({ theme, status }) => (status ? theme.colors.success_80_100 : theme.colors.error_40_100)};
	z-index: 1000;
	cursor: pointer;
`;
